import { render, staticRenderFns } from "./SpecialConsiderationModal.vue?vue&type=template&id=8093488a&scoped=true"
import script from "./SpecialConsiderationModal.vue?vue&type=script&lang=ts"
export * from "./SpecialConsiderationModal.vue?vue&type=script&lang=ts"
import style0 from "./SpecialConsiderationModal.vue?vue&type=style&index=0&id=8093488a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8093488a",
  null
  
)

export default component.exports